var React = require('react');
var mui = require('material-ui');
var withMuiTheme = require('../decorators/withMuiTheme').default;
var DialogMixin = require('lore-hook-dialogs-material-ui/lib/mixins/DialogMixin');

module.exports = withMuiTheme(React.createClass({
  displayName: 'Success',

  mixins: [DialogMixin],

  render: function () {
    var actions = [
      <mui.FlatButton
        label='Close'
        primary={true}
        onTouchTap={this.onCancel}
      />
    ];

    return (
      <mui.Dialog
        title="No connection issues detected"
        modal={false}
        open={this.state.isOpen}
        actions={actions}
        onRequestClose={this.onCancel}
        contentStyle={{maxWidth: '600px'}}
      >
        <div style={{width: '100%', margin: 'auto'}}>
          <div className="dialog-text">
            We found no connectivity issues between your system and our test server. You should be able to
            fully connect to the Data Store from your system.
          </div>
          <div className="dialog-text">
            If you experience any issues, please contact CyVerse Support at <a href="mailto:support@cyverse.org">support@cyverse.org</a>.
          </div>
        </div>
      </mui.Dialog>
    );
  }
}));



// WEBPACK FOOTER //
// ./src/dialogs/Success.js